export type SyncLabel = {
  label: string;
  description: string;
};

const SYNC_LABELS: Record<string, SyncLabel> = {
  full: {
    label: 'Повний цикл',
    description: 'Worker послідовно перевіряє товари, залишки, ціни, lifecycle і чернетки.',
  },
  products: {
    label: 'Товари',
    description: 'Звіряє current каталог 1С із Shopify і створює відсутні товари, якщо це дозволено.',
  },
  inventory: {
    label: 'Залишки',
    description: 'Оновлює наявність варіантів у Shopify за даними 1С.',
  },
  prices: {
    label: 'Ціни',
    description: 'Оновлює ціни варіантів у Shopify за прайсами з 1С.',
  },
  orders: {
    label: 'Замовлення',
    description: 'Передає конкретне замовлення в 1С.',
  },
  orders_queued: {
    label: 'Черга замовлень',
    description: 'Забирає оплачені замовлення з черги і передає їх у 1С пачками.',
  },
};

const STATUS_LABELS: Record<string, SyncLabel> = {
  completed: {
    label: 'Виконано',
    description: 'Прохід завершився без критичної помилки.',
  },
  failed: {
    label: 'Помилка',
    description: 'Прохід не завершився. Технічна причина показана в рядку.',
  },
  running: {
    label: 'Виконується',
    description: 'Прохід зараз активний.',
  },
  conflict: {
    label: 'Зайнято',
    description: 'Інший sync уже виконувався.',
  },
  disabled: {
    label: 'Вимкнено',
    description: 'Цей процес вимкнений налаштуваннями.',
  },
  never_run: {
    label: 'Ще не запускався',
    description: 'У журналі ще немає завершеного проходу.',
  },
};

export function getSyncTypeLabel(type?: string | null): SyncLabel {
  const key = String(type || '').trim();
  return SYNC_LABELS[key] || {
    label: key || 'Невідомий процес',
    description: 'Тип ще не має клієнтського опису. Технічний код залишений для діагностики.',
  };
}

export function getSyncStatusLabel(status?: string | null): SyncLabel {
  const key = String(status || '').trim().toLowerCase();
  return STATUS_LABELS[key] || {
    label: status || 'Невідомо',
    description: 'Статус залишено як технічний код.',
  };
}

export function formatSyncFreshness(status?: string | null, reason?: string | null) {
  const normalizedStatus = String(status || '').toLowerCase();
  const normalizedReason = String(reason || '').toLowerCase();

  if (normalizedStatus === 'ok' && normalizedReason === 'fresh') {
    return 'Актуальна';
  }

  if (normalizedStatus === 'disabled') {
    return 'Вимкнено';
  }

  if (normalizedReason === 'full_sync_lag_exceeded') {
    return 'Потрібен свіжий повний прохід';
  }

  if (normalizedReason === 'no_full_sync_completion') {
    return 'Ще не було повного проходу';
  }

  if (normalizedReason === 'latest_full_sync_failed') {
    return 'Останній повний прохід не завершився';
  }

  if (normalizedReason === 'scheduler_disabled') {
    return 'Автоматична синхронізація вимкнена';
  }

  return reason || status || 'Немає даних';
}
